module.exports = __webpack_public_path__ + "static/media/LoadingScreen.00115459.svg";